import { Validation, Messages } from 'utils/forms/validations';

export const validate = (values) => {
  const errors = {};

  let validationError;

  if (!values.firstName) {
    errors.firstName = Messages.FIELD_IS_REQUIRED;
  }

  if (!values.lastName) {
    errors.lastName = Messages.FIELD_IS_REQUIRED;
  }

  validationError = Validation.email(values.email, true);
  if (validationError) {
    errors.email = validationError;
  }

  validationError = Validation.password(values.password, true);
  if (validationError) {
    errors.password = validationError;
  }

  if (!values.repeatPassword) {
    errors.repeatPassword = Messages.FIELD_IS_REQUIRED;
  } else if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Passwords should match';
  }

  if (!values.acceptTermsAndConditions) {
    errors.acceptTermsAndConditions = Messages.FIELD_IS_REQUIRED;
  }

  validationError = Validation.phone(
    { phone: values.phone, countryCode: values.countryCode },
    true,
  );
  if (validationError) {
    errors.phone = validationError;
  }

  if (Object.keys(errors).length) {
    errors._error = Messages.FILL_IN_ALL;
  }

  return errors;
};
